const STORAGE_KEY = "pd_company_sync_client_id";
let memoryId = "";

export function getCompanySyncClientId() {
  if (memoryId) return memoryId;
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing) {
      memoryId = existing;
      return memoryId;
    }
    memoryId = `web-${crypto.randomUUID()}`;
    sessionStorage.setItem(STORAGE_KEY, memoryId);
    return memoryId;
  } catch {
    memoryId = `web-${crypto.randomUUID()}`;
    return memoryId;
  }
}

export function buildCompanySyncSocketUrl(apiBase, token, tenantKey) {
  const base = (apiBase || "").replace(/\/$/, "");
  const wsBase = base.replace(/^http:/i, "ws:").replace(/^https:/i, "wss:");
  const params = new URLSearchParams();
  if (token) params.set("token", token);
  params.set("clientId", getCompanySyncClientId());
  if (tenantKey) params.set("defaulttenant", String(tenantKey));
  return `${wsBase}/api/company/sync?${params.toString()}`;
}
